import API from "./api";

export class GendersService {

    public getGenders = async () => {
        const res = API.get('/negocio/sexo/opciones');
        return res.then(async (resp) => {
            return resp;
        })
        .catch(err => {
            return err;
        })
    };

}